import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { ApiError, DataTablesService, MessageService, GuidService } from '../../../../core';
import { NaturezaVendaFilter } from '../natureza-venda-filter';
import { NaturezaVenda } from '../../natureza-venda';
import { isSituacaoAtiva, isSituacaoInativa } from '../../situacao';
import { NaturezaVendaCrudHttpService } from '../../services';

@Component({
    selector: 'sgt-natureza-venda-filter-modal',
    templateUrl: './natureza-venda-filter-modal.component.html',
    styleUrls: ['./natureza-venda-filter-modal.component.less']
})
export class NaturezaVendaFilterModalComponent implements OnInit {
    @Input() idModal: string;
    /** Situação padrão. Se informada sempre será considerada esta situação no filtro */
    @Input() situacao: number;
    @Output() selectEntity = new EventEmitter<NaturezaVenda>();
    elModal: any;
    isSelectRegistered = false;

    entities: NaturezaVenda[];
    idDataTable: string;
    dataTable: any;
    filter: NaturezaVendaFilter;
    @ViewChild('modalBody') modalBody: ElementRef;


    constructor(private el: ElementRef,
                private dataTablesService: DataTablesService,
                private messageService: MessageService,
                private naturezaVendaCrudHttpService: NaturezaVendaCrudHttpService,
                private guidService: GuidService) { }

    ngOnInit() {
        this.create();
        this.idDataTable = this.guidService.generate();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
    }

    open(filter: NaturezaVendaFilter = null) {
        this.filter = filter ? filter : new NaturezaVendaFilter();
        this.search();
        this.elModal.modal({keyboard: false});
    }

    close() {
        this.elModal.modal('hide');
    }

    search() {
        // Se tiver a situação padrão informada, sempre adicionamos ela no filtro
        if (this.situacao) {
            this.filter.situacao = this.situacao
        }

        this.naturezaVendaCrudHttpService.searchWithFilter(this.filter)
        .subscribe(
            entities => {
                this.entities = entities;
                this.afterSearch();
            },
            (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar as naturezas de vendas', error)
        );
    }

    private afterSearch() {
        jQuery(this.modalBody.nativeElement).scrollTop(0);
        this.showTable();
    }

    showTable() {
        this.dataTablesService.showTable(jQuery(this.el.nativeElement).find(`#${this.idDataTable}`), this.dataTable, {
            pageLength: 15,
            searching: false,
            order: [[0, 'asc']],
            columnDefs: [
                {orderable: true, targets: 0},
                {
                    targets: 1,
                    createdCell: (td, cellData, rowData, row, col) => {
                        if (cellData) {
                            td.title = cellData;
                        }
                    }
                }
            ],
        }).then(dataTable => this.dataTable = dataTable);
    }

    /** Verifica se a situação da natureza de venda é Ativa */
    isSituacaoAtiva(entity: NaturezaVenda): boolean {
        return isSituacaoAtiva(entity?.situacao);
    }

    /** Verifica se a situação da natureza de venda é Inativa */
    isSituacaoInativa(entity: NaturezaVenda): boolean {
        return isSituacaoInativa(entity?.situacao);
    }

    /** Ao selecionar a natureza de venda emitimos o evento de seleção e fechamos o modal */
    onSelectEntity(entity: NaturezaVenda) {
        this.selectEntity.emit(entity);
        this.close();
    }
}
